import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import useDebounce from "../../utils/hooks";
import "./../../assets/scss/scoped/items-table.scoped.scss";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import { paginationOptions, fetchActionsUtil } from "../../utils/helpers";

export default function VehicleSelectorTable({
  handleSelectedItem,
  url = "api/fleet/vehicles",
  status = "",
  // data = { data: { vehicles: [] } },
}) {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 100,
    q: "",
    status,
  });
  const [vehicles, setVehicles] = useState([]);

  const debouncedqueryParams = useDebounce(queryParams, 500);

  const { data } = useQuery(
    ["VEHICLE_SELECTOR_TABLE", { debouncedqueryParams }],
    () =>
      fetchActionsUtil(
        `${backendUrl}/${url}?${queryString.stringify(queryParams)}`,
        "GET"
      ),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    console.log(data);
    setVehicles(data?.data?.vehicles);
  }, [data]);

  return (
    <div className="items-table-area rounded">
      <div className="search-area m-3">
        <MagnifyIcon />
        <input
          className="form-control search-input"
          name="q"
          value={queryParams.q}
          onChange={(e) =>
            setQueryParams({
              ...queryParams,
              page: 1,
              [e.target.name]: e.target.value,
            })
          }
          placeholder="Search vehicle..."
          autoFocus
          autoComplete="off"
          type={"text"}
        />
      </div>

      <div className="content">
        <Table borderless hover striped className="product-table">
          <thead className="sticky text-nowrap">
            <tr>
              <th scope="col">Fleet Number</th>
              <th scope="col">VIN</th>
              <th scope="col">Make</th>
              <th scope="col">Model</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {vehicles &&
              vehicles.map((el, index) => (
                <tr
                  className="p-cursor"
                  key={index}
                  onClick={() => handleSelectedItem && handleSelectedItem(el)}
                >
                  <td>{el.fleetNumber}</td>
                  <td>{el.vin}</td>
                  <td>{el.make}</td>
                  <td>{el.model}</td>
                  <td>{el.status}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between px-3 my-3 align-items-center pagination">
        <p className="m-0">
          Showing {data?.data?.startIndex + 1} to{" "}
          {data?.data?.endIndex <= data?.data?.count ? data?.data?.endIndex : data?.data?.count} of{" "}
          {data?.data?.count} entries
        </p>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data?.data?.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setQueryParams({
              ...queryParams,
              page: selected + 1,
            });
          }}
          forcePage={queryParams.page - 1}
        />
      </div>
    </div>
  );
}
